const MINDAR_SCRIPT = '/external/vendor/mindar-image-aframe.prod.js';

let loadPromise: Promise<void> | null = null;

export const ensureMindAR = (): Promise<void> => {
    if (window.MINDAR?.IMAGE) {
        return Promise.resolve();
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = MINDAR_SCRIPT;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load MindAR'));
        document.head.appendChild(script);
    });

    return loadPromise;
};
